/**
 * Each drawing standard's guide page (M45, M47; docs/adr/0066-drawing-guides.md):
 * where it is, and what the menu and links call it. The authority in use
 * names its standard, so an architect finds the guide to the drawing they
 * are making.
 */
export interface GuideLink {
  to: string;
  /** The menu's name for it (an i18n key). */
  label: string;
}

const GUIDES: Record<string, GuideLink> = {
  "MMSGNA-2026.10": { to: "/guides/mmsgna", label: "nav.mmsgnaGuide" },
  "AUBB-2026.10": { to: "/guides/aubb", label: "nav.aubbGuide" },
  "OBPAS-2026.06": { to: "/guides/obpas", label: "nav.obpasGuide" },
};

/** The guide to a drawing standard, or undefined if it has none. */
export function guideFor(standard: string | null | undefined): GuideLink | undefined {
  return standard ? GUIDES[standard] : undefined;
}
